export const computerMenuText = "D0b";
export const cloudLocationsMenuText = "E0b";
export const uploadAndShareFromCloudMenuText = "F0b";
export const uploadAndShareFromCloudMenuTooltip = "G0b";
export default {computerMenuText,cloudLocationsMenuText,uploadAndShareFromCloudMenuText,uploadAndShareFromCloudMenuTooltip};